import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HaliPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const carpetTypes = [
    {
      id: 1,
      name: 'Kaşhe Halı - Modern Koleksiyon',
      description: 'Kaşhe\'nin modern tasarımlarıyla evinize çağdaş bir dokunuş',
      image: 'https://public.readdy.ai/ai/img_res/146632d4ad7668aa8b9197980d0b73ff.jpg',
      features: ['Geometrik desenler', 'Yüksek kalite', 'Kolay temizlik'],
      brand: 'Kaşhe'
    },
    {
      id: 2,
      name: 'Kaşhe Halı - Klasik Serisi',
      description: 'Kaşhe\'nin zamansız zarafeti ve geleneksel motifleri',
      image: 'https://readdy.ai/api/search-image?query=Kashe%20brand%20classic%20traditional%20carpet%20with%20intricate%20oriental%20patterns%20in%20rich%20warm%20colors%20displayed%20in%20elegant%20room%20clean%20background%20showcasing%20detailed%20craftsmanship%20and%20premium%20quality%20professional%20product%20photography&width=600&height=700&seq=kashe2&orientation=portrait',
      features: ['Geleneksel motifler', 'Zengin dokular', 'Uzun ömürlü'],
      brand: 'Kaşhe'
    },
    {
      id: 3,
      name: 'Gabardin Halı - Yuvarlak Modeller',
      description: 'Gabardin\'in özgün yuvarlak halı tasarımları',
      image: 'https://readdy.ai/api/search-image?query=Gabardin%20brand%20round%20circular%20carpet%20with%20elegant%20pattern%20in%20neutral%20beige%20tones%20displayed%20in%20modern%20minimalist%20interior%20clean%20white%20background%20showcasing%20unique%20shape%20and%20premium%20quality%20professional%20product%20photography&width=600&height=700&seq=gabardin1&orientation=portrait',
      features: ['Özgün tasarım', 'Mekan vurgusu', 'Çeşitli boyutlar'],
      brand: 'Gabardin'
    },
    {
      id: 4,
      name: 'Gabardin Halı - Salon Koleksiyonu',
      description: 'Gabardin\'in geniş mekanlar için büyük boy halıları',
      image: 'https://readdy.ai/api/search-image?query=Gabardin%20brand%20large%20living%20room%20carpet%20with%20sophisticated%20pattern%20in%20warm%20neutral%20tones%20displayed%20in%20spacious%20modern%20interior%20clean%20background%20showcasing%20size%20and%20premium%20quality%20professional%20product%20photography&width=600&height=700&seq=gabardin2&orientation=portrait',
      features: ['Büyük boyutlar', 'Konforlu doku', 'Ses yalıtımı'],
      brand: 'Gabardin'
    },
    {
      id: 5,
      name: 'Kaşhe Halı - Yatak Odası',
      description: 'Kaşhe\'nin yumuşak ve sıcak dokuları ile konfor',
      image: 'https://readdy.ai/api/search-image?query=Kashe%20brand%20soft%20bedroom%20carpet%20in%20gentle%20pastel%20tones%20with%20plush%20texture%20displayed%20in%20cozy%20bedroom%20setting%20clean%20white%20background%20showcasing%20comfort%20and%20warmth%20professional%20product%20photography&width=600&height=700&seq=kashe3&orientation=portrait',
      features: ['Yumuşak doku', 'Sıcak tutan', 'Rahat his'],
      brand: 'Kaşhe'
    },
    {
      id: 6,
      name: 'Gabardin Halı - Çocuk Odası',
      description: 'Gabardin\'in renkli ve eğlenceli çocuk halıları',
      image: 'https://readdy.ai/api/search-image?query=Gabardin%20brand%20colorful%20playful%20kids%20room%20carpet%20with%20fun%20patterns%20in%20bright%20cheerful%20colors%20displayed%20in%20children%20bedroom%20clean%20white%20background%20showcasing%20child%20friendly%20design%20professional%20product%20photography&width=600&height=700&seq=gabardin3&orientation=portrait',
      features: ['Renkli desenler', 'Güvenli malzeme', 'Kolay temizlik'],
      brand: 'Gabardin'
    }
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Kalite Garantisi',
      description: 'Tüm halılarımızda 2 yıl garanti ve kalite güvencesi sunuyoruz.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Ücretsiz Teslimat',
      description: 'Ankara içi tüm siparişlerinizde ücretsiz teslimat hizmeti.'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Evde Deneme',
      description: 'Halınızı evinizde deneme imkanı ile satın alın.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/urunler" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ürünler</Link>
              <Link to="/hali" className="text-sm font-medium text-amber-600 transition-colors whitespace-nowrap">Halı Satışı</Link>
              <Link to="/ev-tekstili" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ev Tekstili</Link>
              <Link to="/hakkimizda" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/iletisim" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">İletişim</Link>
            </div>

            <Link to="/iletisim" className="hidden lg:block bg-amber-700 hover:bg-amber-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              Teklif Al
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-rose-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6">Halı Satışı</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Evinize sıcaklık ve konfor katan kaliteli halılarımızla tanışın. Modern ve klasik tasarımlardan oluşan geniş koleksiyonumuz.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            {features.map((feature, index) => (
              <div key={index} className="bg-rose-50 rounded-2xl p-8 text-center">
                <div className="w-16 h-16 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${feature.icon} text-3xl text-rose-700`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Carpet Types Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">Halı Çeşitlerimiz</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Her tarza ve mekana uygun halı modellerimizi keşfedin
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {carpetTypes.map((carpet) => (
              <div 
                key={carpet.id}
                className="group cursor-pointer"
              >
                <div className="bg-white rounded-3xl overflow-hidden transition-all hover:shadow-2xl hover:scale-105">
                  <div className="w-full h-96 relative">
                    <img 
                      src={carpet.image} 
                      alt={carpet.name} 
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-bold text-amber-700">{carpet.brand}</span>
                    </div>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{carpet.name}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{carpet.description}</p>
                    <div className="space-y-2">
                      {carpet.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2">
                          <i className="ri-check-line text-rose-600"></i>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-rose-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Showroomumuza Bekleriz</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Halılarımızı yakından görmek ve dokunmak için mağazamızı ziyaret edin. Uzman ekibimiz size yardımcı olmaktan mutluluk duyar.
          </p>
          <Link to="/iletisim" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            İletişime Geç →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}